var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiyalSmDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 9.8153,
    height: 10.92,
    viewBox: "0 0 9.8153 10.92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xEF\xB7\xBC",
    d: "M5.89172 8.52014V6.12028L4.52037 6.39963V7.79637C4.52037 7.90612 4.49498 8.00407 4.44419 8.08842L3.822 8.98995C3.68686 9.21851 3.4837 9.35819 3.21251 9.40898L0 10.082C0.0507907 9.70919 0.152372 9.34549 0.304744 8.98995L3.52995 8.30428V6.61549L0.558698 7.25037C0.601326 6.88667 0.698372 6.51844 0.850744 6.14567L3.52995 5.58698V0.850744C3.80114 0.528767 4.13128 0.245791 4.52037 0V5.37112L5.89172 5.09177V1.44753C6.15384 1.1174 6.48398 0.833512 6.88214 0.596791V4.86321L9.8153 4.24102C9.78174 4.44419 9.74365 4.63465 9.70102 4.81242C9.6584 4.99019 9.59128 5.16795 9.49786 5.34572L6.88214 5.90442V7.27577L9.8153 6.66628C9.78174 6.86128 9.74365 7.04721 9.70102 7.22498C9.6584 7.39458 9.59128 7.56781 9.49786 7.74558L5.89172 8.52014ZM9.8153 9.06614C9.78174 9.25207 9.74365 9.43891 9.70102 9.62484C9.6584 9.81077 9.59128 9.98853 9.49786 10.1581L5.89172 10.92C5.91712 10.725 5.95067 10.5391 5.9933 10.3613C6.04409 10.1917 6.11574 10.0139 6.20916 9.828L9.8153 9.06614Z",
    fill: "#10131D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyalSmDark);
export default __webpack_public_path__ + "static/media/riyal-sm-dark.f72a32f526d0b4da75365cf79acc14f6.svg";
export { ForwardRef as ReactComponent };